import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import { API_URL } from "@/common/config";

let _Store = null;
let _Vue = null;
const ApiService = {
  init(Store) {
    _Store = Store;
    Vue.use(VueAxios, axios);
    Vue.axios.defaults.baseURL = API_URL;
    this.setHeader();
  },

  setVue(vue) {
    _Vue = vue;
  },

  setHeader() {
    Vue.axios.defaults.headers.common["Content-Language"] = "es";

    const token = _Store.getters.user ? _Store.getters.user.token : "";
    if (token) {
      Vue.axios.defaults.headers.common.Authorization = `Token ${token}`;
    }
  },

  query(resource, params) {
    return Vue.axios.get(resource, params).catch(error => {
      throw new Error(`[RWV] ApiService ${error}`);
    });
  },

  get(resource, slug = "", responseExpected) {
    if (slug == null) {
      slug = "";
    }
    console.error(`[${resource}]`, responseExpected);
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(responseExpected);
      }, 400);
    });
  },

  download(resource, slug = "", responseExpected) {
    return Vue.axios
      .get(`${resource}/${slug}`, { responseType: "arraybuffer" })
      .then(result => Promise.resolve(result.data));
  },


  download(resource, slug = "", responseExpected) {
    console.error(`[${resource}]`, responseExpected);
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(responseExpected);
      }, 400);
    });
  },

  post(resource, params, responseExpected) {

    console.error(`[${resource}]`, params, responseExpected);
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(responseExpected);
      }, 400);
    });
  },
  postMultiPart(resource, params) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(responseExpected);
      }, 400);
    });
  },

  _handleError(error) {
    const result = error.response.data;
    if (error.response.status == 401) {
      window.clearInterval(window.threadRealTime);
      _Vue.$root.$children[0].unauthorized(error.response);
      // window.location = "/";
    }
    // else if (error.response.status == 400) {
    //   _Store.commit(SET_ERRORS, error);
    // }

    return Promise.reject(result);
  }
};

export default ApiService;



// WEBPACK FOOTER //
// ./src/common/api.service.js